import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from 'ngx-spinner';
import { fromEvent, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { CategoryService } from 'src/app/services/category.service';
import { SharedService } from 'src/app/services/sharedService';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { UserService } from 'src/app/services/user.service';
import { YearService } from 'src/app/services/year.service';
import { environment } from "../../../environments/environment";
import { ProcessDataSource } from '../../services/process.datasource';
import { ProcessService } from '../../services/process.service';
import { CashPaymentDialogComponent } from '../dialogs/cash-payment-dialog/cash-payment-dialog.component';
import { FillWalletDialogComponent } from '../dialogs/fill-wallet-dialog/fill-wallet-dialog.component';
import { InformationDialogComponent } from '../dialogs/information-dialog/information-dialog.component';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import { CompanyDexieService } from 'src/app/services/companyDexie-services/companyDexie.service';
import { customAlphabet } from 'nanoid';
import { CheckPaymentsDialogComponent } from '../dialogs/check-payments-dialog/check-payments-dialog.component';
import { PoliceTaxDialogComponent } from '../dialogs/police-tax-dialog/police-tax-dialog.component';




@Component({
  selector: 'app-tx-declarations',
  templateUrl: './tx-declarations.component.html',
  styleUrls: ['./tx-declarations.component.css']
})
export class TxDeclarationsComponent implements OnInit, OnDestroy {

  displayedColumns: string[] = ['link', 'name', 'status', 'started_on', 'due_date', 'month','ref_num', 'rec_num'];
  displayedColumnsSmall: string[] = ['link', 'name', 'status'];
  currentYear: any
  currentNIU = '';
  currentYearInt: any
  displayedYears = []
  dataSource: ProcessDataSource;
  company: any;
  isLoading = false;
  user: any;
  category: any;
  recNum
  countRecNum
  subscriptionDeleteDeclaration
  paymentTypes = [];
  paymentTypeMap = {};
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('input', { static: false }) input: ElementRef;
  isOnline: boolean = navigator.onLine;
  name: string;
  constructor(private processService: ProcessService, private yearService: YearService,
    private sharedService: SharedService, public userService: UserService,
    private taxPayerService: TaxPayerService, private companyDexieService: CompanyDexieService,
    private categoryService: CategoryService,
    private route: ActivatedRoute, public dialog: MatDialog, public spinner: NgxSpinnerService) {

  }
  cellClicked(element) {
  }
  addTaxPayerEmmitterSubscription: any
  addCashPaymentEmitterSubscription: any
  fillWalletEmitterSubscription: any
  addPoliceTaxEmitterSubscription: any
  checkPaymentEmitterSubscription: any
  initialLoad = true
  async ngOnInit() {
    if (this.isOnline) {
      try {
        const pmTypes = await this.sharedService.getPaymentTypes().toPromise();
        this.paymentTypes = pmTypes || [];
    
        await this.companyDexieService.addPaymentTypes(this.paymentTypes);
      } catch (err) {
        this.paymentTypes = await this.companyDexieService.getPaymentTypes();
      }
    } else {
      this.paymentTypes = await this.companyDexieService.getPaymentTypes();
    }
    
    this.paymentTypeMap = {};
    this.paymentTypes.forEach(t => this.paymentTypeMap[t.key] = t);
    this.sharedService.onlineStatus$.subscribe(status => {
      this.isOnline = status;
      if (!this.initialLoad) {
        this.dataSource = new ProcessDataSource(this.processService)
        this.getTaxpayer()
      }
      this.initialLoad = false
    });
    this.user = await this.userService.getCurrentUser(this.isOnline).toPromise()
    this.route.queryParams.subscribe(params => {
      this.spinner.show()
      this.isLoading = true
      if (params['tin']) {
        this.currentNIU = params['tin']
      }
      if (params['tkn']) {
        this.currentNIU = params['tkn']
      }
      this.getTaxpayer()
    });

    this.dataSource = new ProcessDataSource(this.processService)
    this.addTaxPayerEmmitterSubscription = this.sharedService.addTaxPayerEmmitter.subscribe(val => {
      this.taxPayerService.getTaxPayerByNiu('tax-payers', this.currentNIU).subscribe(taxPayer => {
        this.spinner.hide()
        this.isLoading = false
        if (!taxPayer) {
          return
        }
        this.company = taxPayer;
      })
    })
    this.addCashPaymentEmitterSubscription = this.sharedService.updateCashPaymentEmmitter.subscribe(async val => {
      if (val) {
        let payment = {
          "paymentSystem": this.getPaymentSystemByKey("cash"),
          "currency": environment.currency.currencyName,
          "amount": val['taxName'].amount,
          "paymentDate": val['date'],
          "tin": this.company.tin,
          "companyName": this.company.name,
          "typeName": this.company.type.name,
          "taxName": val['taxName'].name,
          "taxNameId": val['taxName'].id,
          "revenueCodeId": val['taxName'].revenueCode && val['taxName'].revenueCode.id,
          "revenueCode": val['taxName'].revenueCode && val['taxName'].revenueCode.code,
          "avis": val['taxName'].avis,
          "reference_number": val['taxName'].reference_number,
          "process_name": val['taxName'].origName,
          "month": val['taxName'].month,
          "year": val['taxName'].year,
          "description": val['description']
        }
        if (!this.isOnline) {
          this.companyDexieService.setPayment(payment)
          payment['user'] = await this.companyDexieService.getCurrentUser()
         
          let abbreviatedMunicipality = this.abbreviate(val['municipality'] || '');
          const nanoid = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', 12-abbreviatedMunicipality.length);
          const uniqueId = nanoid();
          payment['paymentReference'] = 'OFF' + abbreviatedMunicipality + uniqueId.toUpperCase();
          const dialogRefConf = this.dialog.open(InformationDialogComponent, {
            width: '500px',
            disableClose: true,
            data: { text: "DIALOG.PAYMENT_SUCCESS" }
          });
          dialogRefConf.afterClosed().subscribe(result => {
            if (result) {
              val['DIALOG'].close();
              this.sharedService.cashPaymentPrint(payment)
            }
          });
        }
        else {
          let res = await this.userService.updateResource('payments', payment).toPromise()
          if (val['taxName'].avis)
            this.companyDexieService.deleteAvis(this.company.tin, val['taxName'].reference_number)
          if (res) {
            if (res.error) {
              this.dialog.open(InformationDialogComponent, {
                width: '500px',
                disableClose: true,
                data: { text: "DIALOG." + res.error, error: true }
              });
            }
            else {
              if (val['sendSMS']) {
                let resp = await this.taxPayerService.sendSMS({ reference_number: val['taxName'].reference_number, telephone: val['telephone'] }).toPromise()
                this.sharedService.smsSend(resp)
              }
              else {
                const dialogRefConf = this.dialog.open(InformationDialogComponent, {
                  width: '500px',
                  disableClose: true,
                  data: { text: "DIALOG.PAYMENT_SUCCESS" }
                });
                dialogRefConf.afterClosed().subscribe(result => {
                  if (result) {
                    val['DIALOG'].close();
                    this.sharedService.cashPaymentPrint(res)
                  }
                });
              }
            }
          }
        }

      }
    })
    this.fillWalletEmitterSubscription = this.sharedService.updateFillWalletEmmitter.subscribe(val => {
      if (val) {
        let wallet = {
          "paymentSystem": this.getPaymentSystemByKey("cash"),
          "currency": environment.currency.currencyName,
          "amount": val['amount'],
          "paymentDate": val['date'],
          "tin": this.company.tin,
          "companyName": this.company.name,
        }
        this.taxPayerService.addBalance(wallet).subscribe(res => {
          if (res) {
            if (res.error) {
              this.dialog.open(InformationDialogComponent, {
                width: '500px',
                disableClose: true,
                data: { text: "DIALOG." + res.error, error: true, data: res.data }
              });
            }
            else {
              const dialogRefConf = this.dialog.open(InformationDialogComponent, {
                width: '500px',
                disableClose: true,
                data: { text: "DIALOG.PAYMENT_SUCCESS" }
              });
              dialogRefConf.afterClosed().subscribe(result => {
                if (result) {
                  val['DIALOG'].close();
                  wallet['user'] = res.user
                  wallet['paymentReference'] = res.paymentReference
                  this.sharedService.cashPaymentPrint(wallet)
                }
              });
            }
          }
        })
      }
    })
    this.addPoliceTaxEmitterSubscription = this.sharedService.updatePoliceTaxEmmitter.subscribe(val => {
      if (!val) {
        return;
      }
      let policeTax = {
        "paymentSystem": this.getPaymentSystemByKey("policeTax"),
        "type": "POLICE-TAX",
        "amount": val['taxName'] && val['taxName']['amount'],
        "paymentDate": val['date'],
        "taxName": val['taxName'] && val['taxName']['name'],
        "revenueCode": val['taxName'] && val['taxName']['revenueCode'] && val['taxName']['revenueCode'][0] && val['taxName']['revenueCode'][0]['code'],
        "revenueCodeId": val['taxName'] && val['taxName']['revenueCode'] && val['taxName']['revenueCode'][0] && val['taxName']['revenueCode'][0]['id'],
        "paymentLocation": val['paymentLocation'],
        "policeTaxType": val['policeTaxType'],
        "tin": this.company.tin,
        "companyName": this.company.name,
      };
    
      if (val['policeTaxType'] === 'vehicle') {
        policeTax['licensePlate']      = val['licensePlate'];
        policeTax['vehicleMake']       = val['vehicleMake'];
        policeTax['vehicleModel']      = val['vehicleModel'];
        policeTax['chassisNumber']     = val['chassisNumber'];
        policeTax['municipalRegistry'] = val['municipalRegistry'];
      }
    
      this.taxPayerService.addBalance(policeTax).subscribe(res => {
        if (res) {
          if (res.error) {
            this.dialog.open(InformationDialogComponent, {
              width: '500px',
              disableClose: true,
              data: { text: "DIALOG." + res.error, error: true, data: res.data }
            });
          } else {
            const dialogRefConf = this.dialog.open(InformationDialogComponent, {
              width: '500px',
              disableClose: true,
              data: { text: "DIALOG.PAYMENT_SUCCESS" }
            });
            dialogRefConf.afterClosed().subscribe(result => {
              if (result) {
                val['DIALOG'].close();
                policeTax['user'] = res.user;
                policeTax['paymentReference'] = res.paymentReference;
                this.sharedService.cashPaymentPrint(policeTax);
              }
            });
          }
        }
      });
    });
    this.checkPaymentEmitterSubscription = this.sharedService.updateCheckPaymentEmmitter.subscribe(val => {
      if (val) {
        let checkPayment = {
          "status": "PENDING",
          "currency": environment.currency.currencyName,
          "type": "CHECK",
          "amount": val['amount'],
          "number": val['number'],
          "source": val['source'],
          "checkDate": val['date'],
          "taxName": val['taxName'],
          "tin": this.company.tin,
          "companyName": this.company.name,
        }
        this.taxPayerService.addCheck(checkPayment).subscribe(res => {
          if (res) {
            if (res.error) {
              this.dialog.open(InformationDialogComponent, {
                width: '500px',
                disableClose: true,
                data: { text: "DIALOG." + res.error, error: true, data: res.data }
              });
            }
            else {
              const dialogRefConf = this.dialog.open(InformationDialogComponent, {
                width: '500px',
                disableClose: true,
                data: { text: "DIALOG.CHECK_PAYMENT_SUCCESS" }
              });
              dialogRefConf.afterClosed().subscribe(result => {
                if (result) {
                  val['DIALOG'].close();
                }
              });
            }
          }
        })
      }
    })
  }

  isArchived() {
    return this.company?.archived;
  }

  getPaymentSystemByKey(key) {
    return this.paymentTypeMap[key] || { key: key, name: key };
  }

  canDeleteDeclaration() {
    if (this.user)
      return ['ADMIN'].includes(this.user.role);
    return false;
  }

  abbreviate(str: string): string {
    const cleaned = str.replace(/[^a-zA-Z]/g, '').toUpperCase();
    return cleaned.substring(0, 3);
  }

  async deleteDeclaration(d) {
    this.recNum = d.rec_num
    let result = await this.processService.getProcessCountByRecNum(this.recNum).toPromise();
    this.countRecNum = result.count
    if (d.last_rec && this.countRecNum > 1 || (d.last_rec && this.countRecNum === 1 && d.status === 'Submitted')) {
      const dialogRef = this.dialog.open(InformationDialogComponent, {
        width: '500px',
        disableClose: true,
        data: { text: "DIALOG.ONGOING_LAST_REC_DELETE_ERROR", error: true }
      })
    } else {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '500px',
        data: { text: "DIALOG.DELETE_DECLARATION", emitter: null, obj: { id: d._id }, action: "CONFIRM", showComment: true }
      });
      this.subscriptionDeleteDeclaration = this.sharedService.confirmDialogEmitter.subscribe(async val => {
        if (val) {
          try {
            await this.processService.deleteDeclaration(val['id']).toPromise()
            let saveDeletion = {
              "type": 'DECLARATION_DELETE',
              "tin": this.company.tin,
              "companyName": this.company.name,
              "comment": val['comment'],
              "municipalityId": this.company.municipality['id'],
              "municipalityName": this.company.municipality['name'],
              "details": {
                'name': d['name'],
                'status': d['status'],
                'started_on': d['started_on'],
                'due_date': d['due_date'],
                'rec_num': d['rec_num'],
                'month': d['month']
              }
            }
            await this.taxPayerService.saveNotificationData(saveDeletion).toPromise();
            this.loadProcessPage()
          } catch (error) {
            console.log('error')
          }
        }
      })

      dialogRef.afterClosed().subscribe(result => {
        this.subscriptionDeleteDeclaration.unsubscribe()
      });
    }
  }

  ngOnDestroy(): void {
    if (this.addTaxPayerEmmitterSubscription) {
      this.addTaxPayerEmmitterSubscription.unsubscribe()
    }
    if (this.addCashPaymentEmitterSubscription) {
      this.addCashPaymentEmitterSubscription.unsubscribe()
    }
    if (this.fillWalletEmitterSubscription) {
      this.fillWalletEmitterSubscription.unsubscribe()
    }
    if (this.checkPaymentEmitterSubscription) {
      this.checkPaymentEmitterSubscription.unsubscribe()
    }
    if (this.addPoliceTaxEmitterSubscription) {
      this.addPoliceTaxEmitterSubscription.unsubscribe()
    }
  }

  async getTaxpayer() {
    this.company = await this.taxPayerService.getTaxPayerByNiu('tax-payers', this.currentNIU, this.isOnline).toPromise()
    this.spinner.hide()
    this.isLoading = false
    if (!this.company) {
      return
    }
    if (this.isOnline) {
      this.category = await this.categoryService.getCategory('category', this.company.type.id).toPromise()
      const years = await this.yearService.getList("year").toPromise()
      years.forEach(element => {
        if (!this.displayedYears.includes(element.year))
          this.displayedYears.push(element.year)
      });
      if (years && years.length > 0) {
        this.currentYear = years[0].year
        this.currentYearInt = years[0].year * 1
      }
      setTimeout(() => {
        this.dataSource.loadProcesses(this.currentYear, '{"tin":"' + this.currentNIU + '","internal":"all"}', 'desc', 'rec_num', 0, this.paginator.pageSize);
        this.setupEventHandlers();
      }, 1000)
      if (this.route.snapshot.paramMap.get('year')) {
        this.currentYear = this.route.snapshot.paramMap.get('year')
      }
    }
  }
  getGovinLink() {
    return environment.govinLink + '/declaration/?token_from_tas=' + localStorage.getItem(environment.accessToken) + '&username=' + this.company.tin
  }

  cashPaymentDialog(): void {
    const dialogRef = this.dialog.open(CashPaymentDialogComponent, {
      width: '500px', panelClass: 'custom-dialog-container',
      data: { tin: this.company.tin }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  policeTaxDialog(): void {
    const dialogRef = this.dialog.open(PoliceTaxDialogComponent, {
      width: '500px', panelClass: 'custom-dialog-container',
      data: { tin: this.company.tin }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  checkPaymentDialog(): void {
    const dialogRef = this.dialog.open(CheckPaymentsDialogComponent, {
      width: '700px', panelClass: 'custom-dialog-container',
      data: { tin: this.company.tin }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  fillInWalletDialog(): void {
    const dialogRef = this.dialog.open(FillWalletDialogComponent, {
      width: '500px', panelClass: 'custom-dialog-container',
      data: { tin: this.company.tin }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  canGoToGovin() {
    if (this.user) {
      return !['MAYOR_TREASURER', 'CENTRAL_READER'].includes(this.user.role)
    }
    return false
  }

  canPayCheck() {
    if (this.user) {
      return ['FINANCIAL_EDITOR'].includes(this.user.role)
    }
    return false
  }

  // canSeeLedger() {
  //   if (this.user) {
  //     // return !['SECRETARY_ASSISTANT'].includes(this.user.role)
  //     return true
  //   }
  //   return false
  // }

  canUpdate() {
    if (this.user) {
      return !['MAYOR_TREASURER', 'CENTRAL_READER', 'SECRETARY_ASSISTANT'].includes(this.user.role)
    }
    return false
  }

  getBackgroundColor(number: number): string {
    if (!number) return "#ffffff";
    const color = this.numberToColorHsl(number);
    return color;
  }

  numberToColorHsl(number: number): string {
    const hash = this.hashNumber(number);
    let hue = (hash * 137) % 360;
    if (hue >= 270 && hue <= 330) {
      hue = (hue + 100) % 360;
    }
    const saturation = 65 + (hash % 20);
    const lightness = 75 + (hash % 10);
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  hashNumber(number: number): number {
    let hash = 0;
    const str = number.toString();
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  handleSelection(event) {
    this.currentYear = event.value;
    this.dataSource.loadProcesses(this.currentYear, '{"tin":"' + this.currentNIU + '","internal":"all"}', 'desc', 'rec_num', 0, this.paginator.pageSize);
  }
  setupEventHandlers() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadProcessPage();
        })
      )
      .subscribe();

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadProcessPage())
      )
      .subscribe();
  }

  loadProcessPage() {
    this.dataSource.loadProcesses(
      this.currentYear,
      '{"query":"' + this.input.nativeElement.value + '" , "tin":"' + this.currentNIU + '","internal":"all"}',
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize);
  }
}
